import { defineMessages } from 'react-intl';

export const scope = 'src.components.DatePickerField';

export default defineMessages({
  invalidDate: {
    id: `${scope}.invalidDate`,
    defaultMessage: 'Invalid',
  },
  minDateError: {
    id: `${scope}.minDateError`,
    defaultMessage: 'Must be greater than or equal to {minDate}',
  },
  daysLabel: {
    id: `${scope}.daysLabel`,
    defaultMessage: 'days',
  },
  dayLabel: {
    id: `${scope}.dayLabel`,
    defaultMessage: 'day',
  },
});
